<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';">
  <ol class="breadcrumb breadcrumb_bg">
    <li *ngFor="let breadcrumb of breadCrumbList; let i = index" class="breadcrumb-item breamcrumb-text">
      {{ breadcrumb }}
    </li>
  </ol>
</nav>

<div class="position-relative cr_content h-auto table-container" style="margin-top:0px">
  <!-- d-none added -->
  <div id="header-container" class="d-none row">
    <div class="col-md-6">
      <div class="search-container">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control" style="font-size: 13px" placeholder="Search" [(ngModel)]="searchValue"
          (input)="applyFilter2($event)" />
      </div>

    </div>
    <div class="col-6 col-md-6pr-0 d-flex justify-content-end align-items-center">
      {{ showingRowsText }}
      1-{{ perPage }} of {{ collectionSize | number }}
      <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
        [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
        [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
      </ngb-pagination>
      <div ngbDropdown class="d-inline-block leftpadding">
        <button class="btn btn-primary btn-sm mr-1" id="dropdownBasic1" ngbDropdownToggle>
          {{ perPage }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem (click)="paginationCall(10)">10</button>
          <button ngbDropdownItem (click)="paginationCall(20)">20</button>
          <button ngbDropdownItem (click)="paginationCall(50)">50</button>
        </div>
        per page
      </div>
    </div>
  </div>
  <!-- d-none ended -->

  <div class="d-flex justify-content-between mb-3">
    <div class="d-flex gap-3">
    </div>
    <div class="d-flex gap-3">
      <div class="header-container">
        <div class="">
          <div class="search-container">
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
              [(ngModel)]="searchValue" (input)="applyFilter2($event)" />
          </div>
        </div>
      </div>
      <div *ngIf="isShowAddFolderButton" class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="addFolderFunc()" (keydown.enter)="addFolderFunc()">
        <i class="fa fa-folder" style="color: white;"></i>
        <span class="reload_text text-white">Add Folder</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Excel')"
        (keydown.enter)="openReport('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
        (keydown.enter)="openReport('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
        (keydown.enter)="openAuditTrail('overAll',0)">
        <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Audit Trail</span>
      </div>
      <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshPage()"
        (keydown.enter)="refreshPage()">
        <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
        <span class="reload_text">Reload</span>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container">
    <tr>
      <th class="py-2" style="width: 100px">
        <div class="d-flex justify-content-between align-items-center">
          <span>Type</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2" style="width: 500px">
        <div class="d-flex justify-content-between align-items-center">
          <span>Title</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2" style="width: 250px;">
        <div class="d-flex justify-content-between align-items-center">
          <span>Status</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2" style="width: 700px;">
        <div class="d-flex justify-content-between align-items-center">
          <span>Actions</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>

    </tr>

    <tr *ngFor="
        let folder of pagedItems | searchFilter : searchValue;
        let i = index
      " (dblclick)="goToSubfolderPage(folder)" (contextmenu)="onRightClick($event, folder)">
      <td>
        <div style="display: flex" *ngIf="folder.isDistributedFolder == 'N'">
          <i class="fa fa-folder-open" style="
              margin-top: 7%;
              font-size: 30px;
              color: #f1ca0ad1;
              margin-left: 30%;
            "></i>

        </div>
        <div style="display: flex" *ngIf="folder.isDistributedFolder == 'Y'">
          <i class="fa fa-folder-open" style="
              margin-top: 7%;
              font-size: 30px;
              color: #f1ca0ad1;
              margin-left: 30%;
            "></i>
          <img alt="img" src="../../assets/img/DMS/google-docs.png"
            style="height: 20px;margin-left: -32%;margin-top: -5%;">
        </div>
      </td>
      <td class="grid-row-container">
        <div>
          <div>
            <span>{{ folder.folderName }}</span>
            <span *ngIf="folder.status == 'Inactive'" style="color: red"><b>&nbsp;&#10060;</b></span>
            <span *ngIf="folder.status == 'Locked'" style="color: red"><b>🔒</b></span>
          </div>
          <div>
            <span *ngIf="folder.folderCode != null">Code : {{ folder.folderCode }}</span>
          </div>
          <div>
            <span *ngIf="folder.folderDescription != null">Description : {{ folder.folderDescription }}</span>
          </div>
          <div>
            <span *ngIf="folder.documentTypeName != null">Type : {{ folder.documentTypeName }}</span>
          </div>
        </div>
      </td>
      <td>
        <span [ngClass]="folder.status == 'Inactive' ||
        folder.status == 'Locked' ||
        folder.status == 'Expired' ||
        folder.status == 'Approval Rejected' ||
        folder.status == 'Review Rejected' ||
        folder.status.includes('Requested More Info.') ||
        folder.status.includes('Expired') ||
        folder.status.includes('Inactive') ||
        folder.status == 'Signoff Rejected' ||
        folder.status == 'Obsoleted' ||
        folder.status == 'Deleted' ? 'delete' : folder.status == 'Active' ? 'approve' :  folder.status == 'Open' ||
        folder.status == 'Draft' ||
        folder.status == 'Pending Review' ||
        folder.status == 'Pending Approval' ||
        folder.status.includes('Inprogress') ||
        folder.status == 'Pending Publish' ||
        folder.status == 'Pending Signoff' ? 'draft' :  folder.status == 'Published' ||
        folder.status.includes('Completed') ? 'closed' :''">{{ folder.status }}</span>

      </td>
      <td class="grid-row-container">
        <div>
          <span>Created On / By :
            {{ folder.createdOn | date : uiDateTimeFormat | uppercase}} /
            {{ folder.createdByUser }}</span>
        </div>
        <div>
          <span>Updated On / By :
            {{ folder.updatedOn | date : uiDateTimeFormat | uppercase }} /
            {{ folder.updatedByUser }}</span>
        </div>
      </td>
    </tr>
  </table>

  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="pagination_text mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

  <div style="visibility: hidden; position: fixed" [style.left]="menuTopLeftPosition.x"
    [style.top]="menuTopLeftPosition.y" [matMenuTriggerFor]="rightMenu"></div>

  <!-- standard material menu -->
  <mat-menu #rightMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button class="right_click_border" *ngFor="let button of item" mat-menu-item
        (click)="performOperationFunc(button)">

        <div class="d-flex gap-2 align-items-center">
          <span class="{{ button.icons }}"></span>
          <span class="right_click_actions">{{button.text}}</span>
        </div>
      </button>
    </ng-template>
  </mat-menu>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div id="filed-container" class="form-continer" style="height: auto !important">
      <div class="row" style="margin-bottom: 10px">
        <div class="col-md-8">
          <div>
            <label for="email ">Folder Name</label><span class="mandatory-symbol">*</span>
          </div>
          <input id="folderName" class="input-filed-continers" type="text" [(ngModel)]="folderData.folderName" />
          <span id="folderName-required-msg">Please enter an folder name</span>
        </div>
        <div class="col-md-4">
          <div><label for="email ">Folder Code</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="folderData.folderCode"
            (keydown)="validateCodeFields($event)" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <div><label for="email">Is Distributed Folder?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.isDistributedFolder1" (change)="onDistributedFolderChange()">
            <span class="active-inActive-container" *ngIf="folderData.isDistributedFolder1 == true" [ngStyle]="
                folderData.isDistributedFolder1 == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.isDistributedFolder1 == false" [ngStyle]="
                folderData.isDistributedFolder1 == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-6" *ngIf="folderData.isDistributedFolder1 == false">
          <div><label for="email">Document Type</label></div>
          <mat-select matInput multiple placeholder="Select" #documentType [(ngModel)]="selectedDocumentType"
            (closed)="documentTypeSearchText=''" (click)="focusSearch('focus-department-search')"
            (keydown.enter)="focusSearch('focus-department-search')">
            <input type="search" id="focus-department-search" class="dropdownsearchstyle"
              [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="documentTypeSelection" (change)="toggleAllSelection('documentType')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
              [value]="item.valueExp" (onSelectionChange)="ondocumentTypeSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4"  *ngIf="folderData.isDistributedFolder1 == false">
          <div><label for="email">Override Document No Format at Folder?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.overrideDocumentNumberFormatAtFolder">
            <span class="active-inActive-container" *ngIf="folderData.overrideDocumentNumberFormatAtFolder == true"
              [ngStyle]="
                folderData.overrideDocumentNumberFormatAtFolder == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.overrideDocumentNumberFormatAtFolder == false" [ngStyle]="
                folderData.overrideDocumentNumberFormatAtFolder == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row" *ngIf="folderData.isDistributedFolder1 == false">
        <div class="col-md-4" *ngIf="settingsObj.allowToInputDocumentNoManually == 'Y'">
          <div><label for="email">Allow To Input Document No. Manually?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.allowToInputDocumentNoManually1">
            <span class="active-inActive-container" *ngIf="folderData.allowToInputDocumentNoManually1 == true"
              [ngStyle]="
                folderData.allowToInputDocumentNoManually1 == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.allowToInputDocumentNoManually1 == false" [ngStyle]="
                folderData.allowToInputDocumentNoManually1 == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-4" *ngIf="settingsObj.allowToInputVersionManually == 'Y'">
          <div><label for="email">Allow To Input Version Manually?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.allowToInputVersionManually1">
            <span class="active-inActive-container" *ngIf="folderData.allowToInputVersionManually1 == true" [ngStyle]="
                folderData.allowToInputVersionManually1 == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.allowToInputVersionManually1 == false" [ngStyle]="
                folderData.allowToInputVersionManually1 == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-4">
          <div><label for="email">Enable Publish Mail For Folder Users?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="folderData.enablePublishMailForFolderUsers1">
            <span class="active-inActive-container" *ngIf="folderData.enablePublishMailForFolderUsers1 == true"
              [ngStyle]="
                folderData.enablePublishMailForFolderUsers1 == true
                  ? { color: 'green' }
                  : { color: '' }
              ">Yes</span>
            <span *ngIf="folderData.enablePublishMailForFolderUsers1 == false" [ngStyle]="
                folderData.enablePublishMailForFolderUsers1 == false
                  ? { color: 'red' }
                  : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row" *ngIf="folderData.overrideDocumentNumberFormatAtFolder">
        <div class="col-md-4">
          <div><label for="email">Document No. Format</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="folderData.documentNoFormat">
        </div>
        <div class="col-md-4">
          <div><label for="email">Document No. Regeneration</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="folderData.documentNoRegeneration">
        </div>
        <div class="col-md-4">
          <div><label for="email">Document Number No. of Digits</label></div>
          <input class="input-filed-continers" type="number" (keydown)="validateNumberFields($event)"
            [(ngModel)]="folderData.documentNoNoOfDigits">
        </div>
      </div>
      <br />
      <div class="row" style="margin-bottom: 2%">
        <div class="col-md-12">
          <div><label for="email ">Folder Description</label></div>
          <textarea id="description" rows="4" class="textarea-filed-continers" type="text"
            [(ngModel)]="folderData.folderDescription"></textarea>
        </div>
      </div>
      <div class="row" style="margin-bottom: 2%" [hidden]="visibleAddButton">
        <div class="col-md-12">
          <div><label for="email ">Update Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="updateReason" rows="4" class="textarea-filed-continers" type="text"
            [(ngModel)]="folderData.updateReason"></textarea>
          <span id="updateReason-required-msg">Please enter update reason</span>
        </div>
      </div>
      <br [hidden]="visibleAddButton">
      <div class="row" *ngIf="visibleAddButton" style="margin-bottom: 2%">
        <div class="col-md-8">
          <div><label for="email">Groups</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedUserGroups" (closed)="groupsSearchText=''"
            (click)="focusSearch('focus-location-search')" (keydown.enter)="focusSearch('focus-location-search')">
            <input type="search" id="focus-location-search" class="dropdownsearchstyle" [(ngModel)]="groupsSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of userGroupsDropdown | assessmentSearch : groupsSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>

        </div>
        <div class="col-md-4">
          <div>
            <label for="email">Cascade Privilege To Child Folders</label>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="cascaseToChild">
            <span class="active-inActive-container" *ngIf="cascaseToChild == true" [ngStyle]="
                cascaseToChild == true ? { color: 'green' } : { color: '' }
              ">Yes</span>
            <span *ngIf="cascaseToChild == false" [ngStyle]="
                cascaseToChild == false ? { color: 'red' } : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(folderData)" (keydown.enter)="addAndEditFunction(folderData)"
      *ngIf="!visibleEditButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(folderData)" (keydown.enter)="addAndEditFunction(folderData)"
      *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="email">Reason For Delete</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="deleteTextarea" type="text" class="input-filed-continers uppercase" rows="4" cols="50"
            [(ngModel)]="deleteReason"></textarea>
          <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #confirmPopup>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="email">Comments</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="comments" type="text" class="textarea-filed-continers" rows="4" cols="50"
            [(ngModel)]="comments"></textarea>
          <span id="comments-required-msg">Please provide the comments</span>
        </div>
      </div>
      <br />
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="confirmOkFunc()"
        (keydown.enter)="confirmOkFunc()">
        <span class="reload_text text-white">{{buttonData.text}}</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #propertiesPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelPropertiesPopupFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Properties - {{ rightClickFolderData.folderName }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div>
    <div style="height: auto;max-height:600px !important;">
      <div class="row">
        <div class="col-md-12">
          <mat-tab-group mat-stretch-tabs class="mat-tab-container mat-elevation-z4" animationDuration="0ms"
            (selectedTabChange)="onTabChanged($event)">
            <mat-tab label="Folder Group Privilege">
              <div class="table-container">
                   <div class="d-flex gap-3"></div>
                <div class="d-flex gap-3">
                  <div class="header-container">
                    <div class="">
                      <div class="search-container">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                      [(ngModel)]="searchValue1">
                      </div>
                    </div>
                  </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReportProperties('Excel')" (keydown.enter)="openReportProperties('Excel')">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                  </div>
                </div>

                <table class="dynamic-table-container documentTable" style="height: 55vh !important;">
                  <thead>
                    <th *ngFor="let column of columnList"
                      [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{column.name}}</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>=
                        </div>
                      </div>
                    </th>
                  </thead>
                  <tbody>
                    <tr>
                      <td *ngFor=" let column of columnList; let ix = index "
                        [ngStyle]="{ 'min-width': column.width != null ? column.width : '200px' }"
                        class="sticky-dynamic-col1">
                        <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter3(column.name, $event,groupAllFolderList)" /> </div>
                      </td>
                    </tr>
                    <tr *ngFor="let group of pagedItemsForPopup | searchFilter : searchValue1; let idx = index;">
                      <td class="grid-row-container" style="text-align: lrft;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'"><span>{{group.groupName}}</span></td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'"><span>{{group.priviledgeType}}</span></td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                      white-space: 'nowrap'"><span>{{group.assignedOn | date : "dd-MMM-yyyy HH:mm:ss"}}</span></td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                        white-space: 'nowrap'"><span>{{group.assignedByname}}</span></td>

                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-center">
                  <div class="width-cheat small paginationCell">
                    <div class="d-flex align-items-center gap-3">
                      <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage }} of {{ collectionForPopup | number }}
                      </div>
                      <div>
                        <ngb-pagination class="leftpadding"
                          (pageChange)="setPageForPopup(pager.currentPage, $event,groupAllFolderList)"
                          [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                          [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                          [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                      </div>
                      <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text dropdownBasic1"
                          ngbDropdownToggle>
                          {{ perPage }}
                          <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                          <button ngbDropdownItem (click)="paginationCall1(10,groupAllFolderList)">10</button>
                          <button ngbDropdownItem (click)="paginationCall1(20,groupAllFolderList)">20</button>
                          <button ngbDropdownItem (click)="paginationCall1(50,groupAllFolderList)">50</button>
                        </div>
                        per page
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </mat-tab>
            <mat-tab label="Folder User Privilege">
              <div class="table-container">
                <div class="d-flex gap-3"></div>
                <div class="d-flex gap-3">
                  <div class="header-container">
                    <div class="">
                      <div class="search-container">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input type="text" class="form-control search_input" style="font-size: 13px; width: 200px;"
                          placeholder="Search" [(ngModel)]="searchValue2">
                      </div>
                    </div>
                  </div>
                  <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReportProperties('Excel')" (keydown.enter)="openReportProperties('Excel')"
                    tabindex="0">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                  </div>
                </div>
                <table class="dynamic-table-container documentTable" style="height: 55vh !important;">
                  <thead>
                    <th *ngFor="let column of columnList"
                      [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{column.name}}</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                  </thead>
                  <tbody>
                    <tr>
                      <td *ngFor=" let column of columnList; let ix = index "
                        [ngStyle]="{ 'min-width': column.width != null ? column.width : '200px' }"
                        class="sticky-dynamic-col1">
                        <div class="row-search-container">
                          <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter3(column.name, $event,groupUsersAllFolderList)" />
                        </div>
                      </td>
                    </tr>
                    <tr *ngFor="let user of pagedItemsForPopup | searchFilter : searchValue2; let idx = index;">
                      <td class="grid-row-container" style="text-align: lrft;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'"><span>{{user.userOrRoleName}}</span></td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.folderAdministrator == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.folderAdministrator == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.author == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img *ngIf="user.author == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                            height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.reviewer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img *ngIf="user.reviewer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                            height="20">
                        </div>
                      </td>

                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.approver == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img *ngIf="user.approver == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                            height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.qa== 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img *ngIf="user.qa == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                            height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.trainingCoordinator == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.trainingCoordinator == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.publisher == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.publisher == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.blinded == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img *ngIf="user.blinded == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                            height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.blindbreak == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.blindbreak == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.redactor== 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img *ngIf="user.redactor == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                            height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.downloader == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.downloader == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.viewer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img *ngIf="user.viewer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                            height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.authorizer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.authorizer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.extensionReviewer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.extensionReviewer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.extensionApprover == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.extensionApprover == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.withdrawalReviewer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.withdrawalReviewer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.withdrawalApprover == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.withdrawalApprover == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container"
                        style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.destructionReviewer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.destructionReviewer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>

                      <td class="grid-row-container"
                        style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.destructionApprover == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                          <img *ngIf="user.destructionApprover == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20">
                        </div>
                      </td>
                      <td class="grid-row-container"
                        style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.printer == 'Y'" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                            height="20">
                          <img *ngIf="user.printer == 'N'" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                            height="20">
                        </div>
                      </td>

                      <td class="grid-row-container"
                        style="text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <div class="gridCheckBoxes">
                          <img *ngIf="user.currentVersionViewer == 'Y'" src="../../assets/img/accessSymbol.svg"
                            alt="Yes" width="20" height="20">
                          <img *ngIf="user.currentVersionViewer == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            alt="No" width="20" height="20">
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-center">
                  <div class="width-cheat small paginationCell">
                    <div class="d-flex align-items-center gap-3">
                      <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage }} of {{ collectionForPopup | number }}
                      </div>
                      <div>
                        <ngb-pagination class="leftpadding"
                          (pageChange)="setPageForPopup(pager.currentPage, $event,groupUsersAllFolderList)"
                          [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                          [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                          [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                      </div>
                      <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text dropdownBasic1"
                          ngbDropdownToggle>
                          {{ perPage }}
                          <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">

                          <button ngbDropdownItem (click)="paginationCall1(10,groupUsersAllFolderList)">10</button>
                          <button ngbDropdownItem (click)="paginationCall1(20,groupUsersAllFolderList)">20</button>
                          <button ngbDropdownItem (click)="paginationCall1(50,groupUsersAllFolderList)">50</button>
                        </div>
                        per page
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="d-none table-container">
                <div class="header-container row">
                  <div class="col-md-6">
                    <div class="search-container">
                      <span class="fa fa-search form-control-feedback"></span>
                      <input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
                        [(ngModel)]="searchValue2" />
                    </div>
                  </div>
                </div>
                <table class="dynamic-table-container">
                  <th style="
                      width: 200px;
                      text-align: center;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span> User or Role</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 200px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Folder Administrator</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 140px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Author</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Reviewer</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Approver</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>QA</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 120px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Training Coordinator</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Publisher</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Blinded</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Blindbreak</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Redactor</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Downloader</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>
                  <th style="
                      width: 100px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: 'ellipsis';
                      white-space: 'nowrap';
                    ">
                    <span>Viewer</span>
                    <span class="fa-solid fa-filter grid-header-container"></span>
                  </th>

                  <tr *ngFor="
                      let user of groupUsersAllFolderList
                        | searchFilter : searchValue2;
                      let idx = index
                    ">
                    <td class="grid-row-container" style="
                        text-align: center;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>{{ user.userOrRoleName }}</span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.folderAdministrator == 'Y'" src="../../assets/img/accessSymbol.svg"
                            width="20" height="20" />
                          <img alt="no" *ngIf="user.folderAdministrator == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            width="20" height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.author == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="no" *ngIf="user.author == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.reviewer == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="no" *ngIf="user.reviewer == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.approver == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="no" *ngIf="user.approver == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.qa == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="no" *ngIf="user.qa == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.trainingCoordinator == 'Y'" src="../../assets/img/accessSymbol.svg"
                            width="20" height="20" />
                          <img alt="no" *ngIf="user.trainingCoordinator == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            width="20" height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.publisher == 'Y'" src="../../assets/img/accessSymbol.svg"
                            width="20" height="20" />
                          <img alt="no" *ngIf="user.publisher == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            width="20" height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.blinded == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="no" *ngIf="user.blinded == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.blindbreak == 'Y'" src="../../assets/img/accessSymbol.svg"
                            width="20" height="20" />
                          <img alt="no" *ngIf="user.blindbreak == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            width="20" height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.redactor == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="no" *ngIf="user.redactor == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.downloader == 'Y'" src="../../assets/img/accessSymbol.svg"
                            width="20" height="20" />
                          <img alt="no" *ngIf="user.downloader == 'N'" src="../../assets/img/noAcessSymbol.svg"
                            width="20" height="20" />
                        </div>
                      </span>
                    </td>
                    <td class="grid-row-container" style="
                        text-align: left;
                        overflow: hidden;
                        text-overflow: 'ellipsis';
                        white-space: 'nowrap';
                      ">
                      <span>
                        <div class="gridCheckBoxes">
                          <img alt="yes" *ngIf="user.viewer == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" />
                          <img alt="no" *ngIf="user.viewer == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                            height="20" />
                        </div>
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
      <br />
    </div>
  </div>
</ng-template>
<ng-template #mapFolderPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelMapFolder()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Map Folder</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="form-continer filed-container">
    <app-distributed-folder [folderData]="folderData"></app-distributed-folder>
  </div>
</ng-template>

<ng-template #templatePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="canceltemplatePopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">Template</label>
      <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div class="form-continer">
      <div class="d-none table-container">
        <div class="header-container row">

          <div class="col-md-4">
            <div class="row-search-container">
              <input type="text" class="form-control" style="font-size: 13px" placeholder="Search1"
                [(ngModel)]="searchValue2" />
            </div>
          </div>

          <div class="col-6 col-md-6pr-0 d-flex justify-content-end align-items-center">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
            <div ngbDropdown class="d-inline-block leftpadding">
              <button class="btn btn-primary btn-sm mr-1 dropdownBasic1" ngbDropdownToggle>
                {{ perPage }}
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall2(10)">
                  10
                </button>
                <button ngbDropdownItem (click)="paginationCall2(20)">
                  20
                </button>
              </div>
              per page
            </div>
          </div>
        </div>
        <div class="header-container row">
          <div class="col-md-2">
            <button type="submit" style="margin-top: 1px; margin-bottom: 1px; margin-left: 40%;color:white;"
              class="addIconContiner" (click)="bulkDownloadTemplates()">
              Download
            </button>
          </div>
        </div>

        <table class="dynamic-table-container">

          <th>
            <span>Template Name.</span>
            <span class="fa-solid fa-filter  multi-filter-container"></span>
          </th>
          <th>
            <span>Template</span>
            <span class="fa-solid fa-filter  multi-filter-container"></span>
          </th>
          <th>
            <span>Template Extn</span>
            <span class="fa-solid fa-filter  multi-filter-container"></span>
          </th>
          <th>
            <span> Is Active?</span>
            <span class="fa-solid fa-filter  multi-filter-container"></span>
          </th>

          <th id="menu" class="sticky-col first-col"></th>
          <tr class="data-row-container" *ngFor="
              let template of pagedItems2 | searchFilter : searchValue2;
              let idx = index
            ">

            <td class="row-data">
              <span>{{ template.templateName }}</span>
            </td>
            <td class="row-data">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="downloadButton" (click)="downloadTemplates(template)">
                  <i class="fa-solid fa-download"></i> View
                </button>
              </div>
            </td>
            <td class="row-data">{{ template.templateExtn }}</td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="yes" *ngIf="template.isActive == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="no" *ngIf="template.isActive == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="table-container">
        <div class="d-flex justify-content-end gap-3 mt-1 mb-3 header-container">

          <button *ngIf="this.multiTemplateArray.length>1" type="submit"
            style="margin-top: 1px; margin-bottom: 1px; margin-left: 40%;color:white;" class="addIconContiner"
            (click)="bulkDownloadTemplates()">
            Download
          </button>

          <div class="">
            <div class="search-container">
              <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                [(ngModel)]="searchValue1">
            </div>
          </div>
        </div>
        <table class="dynamic-table-container documentTable">
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex; justify-content: center; align-items: center;">
              <input id="searchTemplateParentCheckBox" type="checkbox" style="zoom: 1.2;"
                (change)="selectAllTemplate($event)">
            </div>
          </th>
          <th *ngFor="let column of columnList"
            [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>{{column.name}}</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <tr>
            <td>&nbsp;</td>
            <td *ngFor=" let column of columnList; let ix = index "
              [ngStyle]="{ 'min-width': column.width != null ? column.width : '200px' }" class="sticky-dynamic-col1">
              <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter3(column.name, $event,templateList)" /> </div>
            </td>
          </tr>
          <tr *ngFor="let template of pagedItemsForPopup | searchFilter : searchValue1; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="template.searchTemplateChildCheckBox ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="template.searchTemplateChildCheckBox"
                    (change)="onChildCheckBoxChanged($event, template, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">
              <span>{{ template.templateName }}</span>
            </td>
            <td class="row-data">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="downloadButton" (click)="downloadTemplates(template)">
                  <i class="fa-solid fa-download"></i> Download
                </button>
              </div>
            </td>
            <td class="row-data">{{ template.templateExtn }}</td>
            <td class="row-data">
              <div class="gridCheckBoxes">
                <img alt="yes" *ngIf="template.isActive == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" />
                <img alt="no" *ngIf="template.isActive == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" />
              </div>
            </td>
          </tr>
        </table>
        <div class="d-flex justify-content-center">
          <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
              <div class="pagination_text mt-3">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionForPopup | number }}
              </div>
              <div>
                <ngb-pagination class="leftpadding"
                  (pageChange)="setPageForPopup(pager.currentPage, $event,templateList)" [disabled]="false"
                  [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                  [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
              </div>
              <div ngbDropdown class="mt-3">
                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text dropdownBasic1" ngbDropdownToggle>
                  {{ perPage }}
                  <i class="ms-1 fa-solid fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall1(10,templateList)">10</button>
                  <button ngbDropdownItem (click)="paginationCall1(20,templateList)">20</button>
                  <button ngbDropdownItem (click)="paginationCall1(50,templateList)">50</button>
                </div>
                per page
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #downloadTemplatePopup>
  <h2 mat-dialog-title>Download Template</h2>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="reason"> Reason</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="downloadReason" rows="4" class="textarea-filed-continers" type="text"
            [(ngModel)]="reason"></textarea>
          <div id="reason-val-icon" class="field-icon-container"></div>
          <span id="downloadReason-required-msg" style="display: none; color: red; font-size: 12px;">Please enter
            reason</span>
        </div>
      </div>
      <br />
    </div>

    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="downloadType=='single'"
        (click)="downloadTemplateForFolder()" (keydown.enter)="downloadTemplateForFolder()">
        <span class="reload_text text-white">Download</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="downloadType=='bulk'"
        (click)="bulkDownloadTemplateForFolder()" (keydown.enter)="bulkDownloadTemplateForFolder()">
        <span class="reload_text text-white">Download</span>
      </div>

      <button mat-stroked-button class="cancelButton" (click)="cancelDownloadTemplateFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #addUserGroupPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddUserGroupPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Add UserGroup</label>
      <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>
    <div style="
        height: auto;
        max-height: 570px;
        overflow-y: hidden;
        padding: 10px;
        overflow-x: hidden;
      ">
      <div class="d-none table-container">
        <div class="header-container row">
          <div class="col-md-4">
            <div class="row-search-container">
              <input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
                [(ngModel)]="searchValue3" />
            </div>
          </div>
          <div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center">
            {{ showingRowsText }}
            1-{{ perPage3 }} of {{ collectionForPopup | number }}
            <ngb-pagination class="leftpadding" (pageChange)="setPage3(pager3.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager3.totalItems" [(page)]="pager3.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage3" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
            <div ngbDropdown class="d-inline-block leftpadding">
              <button class="btn btn-primary btn-sm mr-1 dropdownBasic1" ngbDropdownToggle>
                {{ perPage }}
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall3(10)">
                  10
                </button>
                <button ngbDropdownItem (click)="paginationCall3(20)">
                  20
                </button>
              </div>
              per page
            </div>
          </div>
        </div>
        <table class="dynamic-table-container" style="height: 50vh !important;">
          <thead>
            <th></th>
            <th>
              <span>Group Name</span>
              <span class="fa-solid fa-filter  multi-filter-container"></span>
            </th>
            <th>
              <span>Description</span>
              <span class="fa-solid fa-filter  multi-filter-container"></span>
            </th>
            <th>
              <span> Is Active?</span>
              <span class="fa-solid fa-filter  multi-filter-container"></span>
            </th>

            <th class="sticky-col first-col menu"></th>
          </thead>
          <tbody>
            <tr class="data-row-container" *ngFor="
                let group of pagedItems3 | searchFilter : searchValue3;
                let idx = index
              ">
              <td style="min-width: 80px; text-align: center">
                <div style="display: flex">
                  <div [ngClass]="
                      group.grouptChildCheckBoxs
                        ? 'static_icon'
                        : 'hover-menu-icons'
                    ">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px">
                    <input id="selectedGroupCheckBox" type="checkbox" style="zoom: 1.2"
                      [checked]="group.grouptChildCheckBoxs" (change)="
                        dataGridGroupChildCheckBoxChecked($event, group, idx)
                      " />
                  </div>
                </div>
              </td>
              <td class="row-data">
                <span>{{ group.groupName }}</span>
              </td>
              <td class="row-data">{{ group.groupDescription }}</td>
              <td class="row-data">
                <div class="gridCheckBoxes">
                  <img alt="yes" *ngIf="group.isActive == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                    height="20" />
                  <img alt="no" *ngIf="group.isActive == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                    height="20" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-container">
        <div class="header-container d-flex justify-content-end gap-3 mt-1 mb-3">
          <div class="">
            <div class="search-container">
              <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                [(ngModel)]="searchValue1">
            </div>
          </div>
        </div>
        <table class="dynamic-table-container documentTable" style="height: 50vh !important;">
          <thead>
            <th style="min-width:60px;max-width:60px;"></th>
            <th *ngFor="let column of columnList"
              [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>{{column.name}}</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img alt="sort" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td *ngFor=" let column of columnList; let ix = index "
                [ngStyle]="{ 'min-width': column.width != null ? column.width : '200px' }" class="sticky-dynamic-col1">
                <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                    (input)="applyFilter3(column.name, $event,dmsGroupsList)" /> </div>
              </td>
            </tr>
            <tr *ngFor="let group of pagedItemsForPopup | searchFilter : searchValue1; let idx = index;">
              <td style="min-width: 80px; text-align: center">
                <div style="display: flex">
                  <div [ngClass]="
                  group.grouptChildCheckBoxs
                    ? 'static_icon'
                    : 'hover-menu-icons'
                ">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px">
                    <input id="selectedCheckBox" type="checkbox" style="zoom: 1.2"
                      [checked]="group.grouptChildCheckBoxs" (change)="
                    dataGridGroupChildCheckBoxChecked($event, group, idx)
                  " />
                  </div>
                </div>
              </td>
              <td class="row-data">
                <span>{{ group.groupName }}</span>
              </td>
              <td class="row-data">{{ group.groupDescription }}</td>
              <td class="row-data">
                <div class="gridCheckBoxes">
                  <img alt="yes" *ngIf="group.isActive == 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                    height="20" />
                  <img alt="no" *ngIf="group.isActive == 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                    height="20" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
              <div class="pagination_text mt-3">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionForPopup | number }}
              </div>
              <div>
                <ngb-pagination class="leftpadding"
                  (pageChange)="setPageForPopup(pager.currentPage, $event,dmsGroupsList)" [disabled]="false"
                  [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                  [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
              </div>
              <div ngbDropdown class="mt-3">
                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text dropdownBasic1" ngbDropdownToggle>
                  {{ perPage }}
                  <i class="ms-1 fa-solid fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall1(10,dmsGroupsList)">10</button>
                  <button ngbDropdownItem (click)="paginationCall1(20,dmsGroupsList)">20</button>
                  <button ngbDropdownItem (click)="paginationCall1(50,dmsGroupsList)">50</button>
                </div>
                per page
              </div>
            </div>
          </div>
        </div>

      </div>
      <br />
      <div class="row">
        <div class="col-md-4">
          <div>
            <label for="email">Cascade Privilege To Child Folders</label>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="cascaseToChild">
            <span class="active-inActive-container" *ngIf="cascaseToChild == true" [ngStyle]="
                cascaseToChild == true ? { color: 'green' } : { color: '' }
              ">Yes</span>
            <span *ngIf="cascaseToChild == false" [ngStyle]="
                cascaseToChild == false ? { color: 'red' } : { color: '' }
              ">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <br />
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addUserGroupFunc()"
        (keydown.enter)="addUserGroupFunc()">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white"> {{ buttonData.text }}</span>
      </div>

      <button mat-stroked-button class="cancelButton" (click)="cancelAddUserGroupPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup1>
 
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-homepagetag #tagRecordPopup (valueEmitter)="onTagChildValueEmitted()"></app-homepagetag>